import type { Review } from "@/data/reviewTypes";

export const TAMPA_REVIEWS: Review[] = [
  { name: "Miguel K.", initials: "MK", rating: 5, date: "1 week ago", text: "TPA curbside pickup for a 14-person crew to Raymond James Stadium. Sprinter was spotless, driver knew every Tampa shortcut. Booking again." },
  { name: "Sara R.", initials: "SR", rating: 5, date: "3 weeks ago", text: "Bachelorette weekend around Downtown Tampa. Easy delivery to our hotel, captain's chairs, cold AC even in Tampa heat. Perfect." },
  { name: "Devon T.", initials: "DT", rating: 5, date: "1 month ago", text: "Booked the 15-passenger for Tampa game day. On-time, full tank, no surprise charges. Best van rental in Tampa Bay." },
];
